export enum ProductFlag {
  LimitedInventory = 'limited_inventory',
  New = 'new',
  Sale = 'sale',
  ShipsSoon = 'ships_soon',
}
